import p1_img from "./DSC09184.jpg";
import p2_img from "./DSC08780.jpg";
import p3_img from "./DSC08780.jpg";
import p4_img from "./DSC09184.jpg";
import p5_img from "./DSC08890.jpg";
import p6_img from "./DSC09184.jpg";
import p7_img from "./imag3.png";
import p8_img from "./image1.jpg";
import p13_img from "./DSC09184.jpg";
import p14_img from "./image1.jpg";
import p15_img from "./DSC09184.jpg";
import p16_img from "./imag3.png";
import p17_img from "./DSC09184.jpg";
import p18_img from "./image1.jpg";
import p19_img from "./DSC09184.jpg";
import p20_img from "./DSC09184.jpg";
import p21_img from "./image1.jpg";
import p22_img from "./imag3.png";
import p23_img from "./DSC09184.jpg";
import p24_img from "./DSC09184.jpg";
import p25_img from "./DSC09269.jpg";
import p26_img from "./DSC09216.jpg";
import p27_img from "./DSC08780.jpg";
import p28_img from "./DSC09162.jpg";
import p29_img from "./DSC09184.jpg";
import p30_img from "./DSC09246.jpg";
import p31_img from "./DSC09184.jpg";
import p32_img from "./image1.jpg";
import p33_img from "./DSC09184.jpg";
import p34_img from "./DSC09269.jpg";
import p35_img from "./DSC09184.jpg";
import p36_img from "./image1.jpg";

let all_product = [
  {
    id: 1,
    name: "FLUTTER DRESS",
    category: "women",
    image: p1_img,
    new_price: 50.0,

  },
  {
    id: 2,
    name: "FLUTTER DRESS",
    category: "women",
    image: p2_img,
    new_price: 85.0,

  },
  {
    id: 3,
    name: "FLUTTER DRESS",
    category: "women",
    image: p3_img,
    new_price: 100.0,

  },
  {
    id: 4,
    name: "FLUTTER DRESS",
    category: "women",
    image: p4_img,
    new_price: 120.0,

  },
  {
    id: 5,
    name: "FLUTTER DRESS",
    category: "women",
    image: p5_img,
    new_price: 850.0,

  },
  {
    id: 6,
    name: "Striped Flutter Sleeve  Blouse",
    category: "women",
    image: p6_img,
    new_price: 805.0,

  },
  {
    id: 7,
    name: "Striped Flutter Sleeve  Blouse",
    category: "women",
    image: p7_img,
    new_price: 875.0,

  },
  {
    id: 8,
    name: "Striped Flutter Sleeve  Blouse",
    category: "women",
    image: p8_img,
    new_price: 835.0,

  },
  {
    id: 13,
    name: " Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p13_img,
    new_price: 85.0,

  },
  {
    id: 14,
    name: "Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p14_img,
    new_price: 85.0,

  },
  {
    id: 15,
    name: " Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p15_img,
    new_price: 85.0,

  },
  {
    id: 16,
    name: " Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p16_img,
    new_price: 85.0,

  },
  {
    id: 17,
    name: " Jacket",
    category: "men",
    image: p17_img,
    new_price: 85.0,

  },
  {
    id: 18,
    name: " Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p18_img,
    new_price: 85.0,
  
  },
  {
    id: 19,
    name: "Slim Fit Bomber Jacket",
    category: "men",
    image: p19_img,
    new_price: 85.0,
   
  },
  {
    id: 20,
    name: " Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p20_img,
    new_price: 85.0,
  
  },
  {
    id: 21,
    name: " Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p21_img,
    new_price: 85.0,
 
  },
  {
    id: 22,
    name: " Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p22_img,
    new_price: 85.0,
 
  },
  {
    id: 23,
    name: " Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p23_img,
    new_price: 85.0,
   
  },
  {
    id: 24,
    name: " Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p24_img,
    new_price: 85.0,

  },
  {
    id: 25,
    name: " Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p25_img,
    new_price: 85.0,
 
  },
  {
    id: 26,
    name: " Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p26_img,
    new_price: 85.0,
  
  },
  {
    id: 27,
    name: " Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p27_img,
    new_price: 85.0,
  
  },
  {
    id: 28,
    name: " Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p28_img,
    new_price: 85.0,

  },
  {
    id: 29,
    name: "Hooded Sweatshirt",
    category: "kid",
    image: p29_img,
    new_price: 85.0,
 
  },
  {
    id: 30,
    name: " Hooded Sweatshirt",
    category: "kid",
    image: p30_img,
    new_price: 85.0,

  },
  {
    id: 31,
    name: " Hooded Sweatshirt",
    category: "kid",
    image: p31_img,
    new_price: 85.0,

  },
  {
    id: 32,
    name: " Hooded Sweatshirt",
    category: "kid",
    image: p32_img,
    new_price: 85.0,
  
  },
  {
    id: 33,
    name: " Hooded Sweatshirt",
    category: "kid",
    image: p33_img,
    new_price: 85.0,
 
  },
  {
    id: 34,
    name: " Sweatshirt",
    category: "kid",
    image: p34_img,
    new_price: 85.0,

  },
  {
    id: 35,
    name: "Sweatshirt",
    category: "kid",
    image: p35_img,
    new_price: 85.0,

  },
  {
    id: 36,
    name: " Colourblocked ",
    category: "kid",
    image: p36_img,
    new_price: 85.0,

  },
];

export default all_product;
